module.exports = __webpack_public_path__ + "static/VWT20_Paar_2048x1366-f360a6e5685b80f6a96c21f2495608d0.jpg";